import React, { Component } from 'react';
import LangItem from './LangItem';
import PropTypes from 'prop-types';


class LangContainer extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const langItems = this.props.lang.length > 0 ? this.props.lang.map((lang) => {
            return <LangItem lang={lang.nameNative} iso3Code={lang.countryIso3} iso={lang.isocode} key={lang.id} 
                    activeLang={this.props.activeLang}/> 
        }) : '';
        return(
            <div className={`lang-container ${this.props.isShow ? 'show' : ''}`}>
                {langItems}
            </div>
        )
    }
}

export default LangContainer;

LangContainer.propTypes = {
    lang: PropTypes.array.isRequired,
    isShow: PropTypes.bool.isRequired,
    activeLang: PropTypes.func.isRequired,
}

